import { Box, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import Header from '../../components/special/Header';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { DBRequest, useConfig } from '../../api/api';
import CardGrid from '../../components/cards/layout/CardGrid';
import { ProjectAddElementButton } from '../../components/exo/project/ProjectAddElementButton';
import { hasPermissions } from '../../auth/hasPermissions';
import { ExoSkeleton } from '../../components/exo/ExoSkeleton';
import { SalesObjectGridItem } from './SalesObjectGridItem';
import { NewSalesObject } from '../../components/new/NewSalesObject';
import ExoDialog from '../../components/exo/ExoDialog';
import { updateOrCreate } from '../../components/special/updateOrCreate';

const SalesObjects = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const { t } = useTranslation();

  const [salesObjects, setSalesObjects] = useState(null);
  const [salesStatus, setSalesStatus] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    loadSalesObjects(0);
  }, [config]);

  function loadSalesObjects(status) {
    setSalesStatus(status);
    DBRequest({
      config,
      path: 'sales-objects?sortOrder=desc',
      onResponse: setSalesObjects,
    });
  }

  function handleSalesObject(data) {
    setOpen(false);
    setSalesObjects(updateOrCreate(salesObjects, data.data));
  }

  return (
    <>
      <Box className="flex gap-0 md:gap-8 md:items-center justify-between md:justify-start pr-2 md:flex-row flex-col pb-4 md:pb-0">
        <Header title={t('Sales objects')} />
        <ToggleButtonGroup
          size="small"
          value={salesStatus}
          exclusive
          onChange={(e) => loadSalesObjects(e.target.value)}
          aria-label="Sales status"
          className="backdrop-blur-lg"
        >
          <ToggleButton value="0">{t('available')}</ToggleButton>
          <ToggleButton value="1">{t('sold')}</ToggleButton>
          <ToggleButton value="2">{t('canceled')}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <CardGrid className="overflow-y-auto pb-4">
        {hasPermissions('project', 'write') && (
          <ProjectAddElementButton onClick={() => setOpen(true)} />
        )}
        {!salesObjects ? (
          <ExoSkeleton n={5} size="100%" />
        ) : (
          <>
            {salesObjects.data.map((item) => (
              <SalesObjectGridItem key={item.id} item={item} />
            ))}
          </>
        )}
      </CardGrid>
      <ExoDialog open={open} onClose={() => setOpen(false)} limitWidth>
        <NewSalesObject
          onClose={() => setOpen(false)}
          onUpdate={handleSalesObject}
          onCreate={handleSalesObject}
        />
      </ExoDialog>
    </>
  );
};

export default SalesObjects;
